import { config } from '@fortawesome/fontawesome-svg-core';
import axios from 'axios';
import { boolean } from 'yup';
import endpoints from './endpoint';

const httpClient = axios.create();

httpClient.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  config.headers = {
    key: `${process.env.REACT_APP_TOKEN_KEY}`,
    Authorization: token ? `Bearer ${token}` : '',
  };
  // config.headers = { key: 'efb11082f54703d1' };
  return config;
});

httpClient.interceptors.response.use(
  (response) => {
    try {
      
      const apiUrl = response?.request?.responseURL;
      const requestBody = response?.data;
      let headers = response?.config?.headers;
      delete headers?.key;
      delete headers?.Authorization;
      const queryParams = response?.config?.params;
      const httpStatusCode = response?.status;
      const method = response?.config?.method;
      let reqBody = {
        apiUrl,
        headers,
        queryParams,
        httpStatusCode,
        method,
      };
      if(['post', 'put', 'patch'].includes(method)) {
        Object.assign(reqBody,{requestBody});
      }
      const token = localStorage.getItem('token');
      axios.post(endpoints.reports.cmsLogReport(),reqBody,{
        headers: {
          key: `${process.env.REACT_APP_TOKEN_KEY}`,
          Authorization: token ? `Bearer ${token}` : '',
        }
      });
    }
    catch (error) {
      console.log(error)
    }
    return response;
  },
  (error) => {
    console.log(error);
    if (Number(error.response.status) === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default httpClient;
